import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesInternalBank } from "../../constants";
import { InternalBankReplenishBody } from "./internalBankReplenish.types";

export const requestInternalBankReplenish = async ({
  amount
}: InternalBankReplenishBody): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesInternalBank.InternalBankReplenish),
    {
      amount
    }
  );
};
